const question5 = {
    'question': 'Jaki czas jest przeznaczony na jedno spotkanie terapii par?',
    'answer': 'Czas przeznaczony na jedno spotkanie terapii par wynosi od 1 godziny do 2 godzin. Jest to kwestia indywidualna, która jest ustalana z terapeutą podczas pierwszego spotkania konsultacyjnego.',
}

export default question5;